import { render, staticRenderFns } from "./AskConversations.vue?vue&type=template&id=5c88313c&scoped=true&"
import script from "./AskConversations.vue?vue&type=script&setup=true&lang=js&"
export * from "./AskConversations.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AskConversations.vue?vue&type=style&index=0&id=5c88313c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c88313c",
  null
  
)

export default component.exports